const ROOT_SELECTOR = ".collection-seo-description";
const TOGGLE_SELECTOR = ".collection-seo-description__toggle";
const TEXT_SELECTOR = ".collection-seo-description__text";
const OPEN_CLASS = "is-open";
const READY_CLASS = "is-ready";

const initCollectionSeoDescription = (root: ParentNode): void => {
  const section = root.querySelector<HTMLElement>(ROOT_SELECTOR);
  if (!section) return;

  const btn = section.querySelector<HTMLButtonElement>(TOGGLE_SELECTOR);
  if (!btn) return;

  const id = btn.getAttribute("aria-controls");
  const wrap = id ? document.getElementById(id) : null;
  if (!wrap) return;

  const text = wrap.querySelector<HTMLElement>(TEXT_SELECTOR);
  if (!text) return;

  wrap.classList.remove(OPEN_CLASS);
  btn.setAttribute("aria-expanded", "false");
  wrap.setAttribute("aria-hidden", "false");

  const isClamped = (): boolean => text.scrollHeight > text.clientHeight + 1;

  if (!isClamped()) return;

  btn.classList.add(READY_CLASS);

  btn.addEventListener("click", () => {
    const nextExpanded = btn.getAttribute("aria-expanded") !== "true";
    btn.setAttribute("aria-expanded", String(nextExpanded));
    wrap.classList.toggle(OPEN_CLASS, nextExpanded);
    wrap.setAttribute("aria-hidden", "false");
  });
};

initCollectionSeoDescription(document);
document.addEventListener("shopify:section:load", (e) => {
  const target = e.target;
  if (target instanceof HTMLElement) initCollectionSeoDescription(target);
});
